<template>
  <div>
    <Pagination
      v-if="typeof loadMore == 'undefined'"
      v-model="currentPage"
      :records="totalRecords"
      :per-page="limit"
      class="m-2"
      @input="paginationPageChanged(currentPage)"
      @paginate="setClickedPage"
    ></Pagination>
    <div
        class="row w-100 my-lg-3 justify-content-center"
        v-if="pagination.total > 0 && pagination.perPage < pagination.total"
    >
      <button
          v-if="(currentPage*limit < totalRecords) && (typeof loadMore != 'undefined' && !hideLoadMore)"
          @click="loadMoreRecords"
          class="btn btn-primary mr-1 d-flex"
          :disabled="loading"
      >
        <Loader :loading="loading" size="10px"></Loader>
        Load More
      </button>
    </div>
  </div>
</template>


<script>
import {mapState} from "vuex";

export default {
  emits: ["getRecords"],
  props: [
    "url",
    "data",
    "search",
    "infiniteLoad",
    "force",
    "formData",
    "submit",
    "submitUrl",
    "hideLoader",
    "updateForm",
    "hidePagination",
    "hideLimit",
    "defaultLimit",
    "defaultLimitClass",
    "defaultLimitText",
    "bodyData",
    "storageKey",
    "externalTotalRecord",
    "loadMore",
    "multipleTimeForceApi"
  ],
  data() {
    return {
      dataUrl: "",
      records: [],
      pagination: "",
      loading: true,
      noRecordFound: false,
      callInProgress: false,
      limit: this.defaultLimit ? this.defaultLimit : 10,
      currentPage: 1,
      clickedPage: 1,
      hideLoadMore: false
    };
  },
  mounted() {
    this.dataUrl = this.url;
    setTimeout(() => {
      if (!this.infiniteLoad) {
        this.getList(false);
      }
    }, 1000);
  },
  methods: {
    loadMoreRecords() {
      let total = this.pagination.total;
      let perPage = this.pagination.perPage;
      let totalPages = parseInt(total / perPage) + 1;
      if (this.currentPage == totalPages) {
        this.hideLoadMore = true;
      } else {
        this.currentPage += 1;
      }
    },
    paginationPageChanged(page) {
      var url = this.dataUrl;
      var params = this.data;
      var data = {
        page: 1,
        perPage: this.limit,
      };
      if (this.bodyData) {
        data = Object.assign(data, this.bodyData);
      }

      //  if (typeof url == "undefined" || url == "") {
      //    return false;
      //  }
      if (!this.hideLoader) {
        this.loading = true;
      }

      if (typeof page !== "undefined" && page) {
        data.page = page;
      }
      if (typeof params !== "undefined") {
        (data.flag = params.flag), (data.type = params.type);
      }
      //  if (this.callInProgress) {
      //    return false;
      //  }
      url = localStorage.getItem("url");
      this.makeRequest("post", url, data, {}, false).then(callResponse => {
        this.callInProgress = false;
        this.loading = false;
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            var response = callResponse.response.data.data;
            var result = {
              data: response.data ? response.data : response,
              noRecordFound: false,
              pagination: response.paginationData,
              fullResponse: response
            };
            this.setDataInStore(result);
            if (response.paginationData) {
              this.currentPage = response.paginationData.currentPage;
            }
            this.$emit("getRecords", result);
            this.pagination = response.paginationData;
          } else if (code == 400 || code == 205) {
            this.$emit("hideLoader", false);
          }
        }
      });
    },
    setClickedPage(val) {
      this.clickedPage = val;
      this.$emit("pageChanged", this.loading);
    },
    setDataInStore(result) {
      // let storeData = this.$store.getters["get" + this.storageKey];
      let storeData = this.$store.getters.getByKey(this.storageKey);
      if (storeData == null) {
        storeData = {};
      }
      // if (result.pagination) {
      //   if (result.pagination.currentPage == 1) {
      //     storeData.firstPageData = result;
      //   }
      // } else {
      //   storeData.otherPageData = result;
      // }

      if (result.pagination) {
        if (result.pagination.currentPage == 1) {
          storeData.firstPageData = result;
        }
        else {
          storeData.otherPageData = result;
        }
      }
      storeData.key = this.storageKey;
      this.$store.dispatch("set", storeData);
    },
    urlChange() {
      this.storageKey = "";
    },
    getList(page) {
      var url = this.dataUrl;
      var params = this.data;
      var data = {
        page: 1,
        perPage: this.limit,
      };
      if (this.bodyData) {
        data = Object.assign(data, this.bodyData);
      }

      if (typeof url == "undefined" || url == "") {
        return false;
      }
      if (!this.hideLoader) {
        this.loading = true;
      }

      if (typeof page !== "undefined" && page) {
        data.page = page;
      }
      if (typeof params !== "undefined") {
        (data.flag = params.flag), (data.type = params.type);
      }
      if (this.callInProgress) {
        return false;
      }

      this.callInProgress = true;
      // alert(page+'   getlist')
      let storeData = this.$store.getters.getByKey(this.storageKey);
      // console.log(storeData)
      // console.log(this.clickedPage,'clicked page')
      if (storeData != null) {
        if (page == 1 || page == false) {
          if (typeof (storeData.firstPageData) != 'undefined') {
            this.currentPage = storeData.firstPageData.pagination.currentPage;
            this.$emit("getRecords", storeData.firstPageData);
            this.pagination = storeData.firstPageData.pagination;
            this.callInProgress = false;
            this.loading = false;
            return;
          }
        } else {
          // localStorage.removeItem(key);
          if (typeof (storeData.otherPageData) != 'undefined') {
            if (page == storeData.otherPageData.pagination.currentPage) {
              this.currentPage = storeData.otherPageData.pagination.currentPage;
              this.$emit("getRecords", storeData.otherPageData);
              this.pagination = storeData.otherPageData.pagination;
              this.callInProgress = false;
              this.loading = false;
              return;
            }
          }
        }
      }
      if (this.url !== this.storageKey) {
        this.makeRequest("post", url, data, {}, false).then(callResponse => {
          this.callInProgress = false;
          this.loading = false;
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              var response = callResponse.response.data.data;
              if(!response){
                response = {
                  data: [],
                  paginationData:{
                    currentPage:1,
                    perPage:"10",
                    total:0
                  }
                }
              }
              var result = {
                data: response?.data ? response.data : response,
                noRecordFound: false,
                pagination: response?.paginationData,
                fullResponse: response
              };
              this.setDataInStore(result);
              if (response?.paginationData) {
                this.currentPage = response.paginationData.currentPage;
              }
              this.$emit("getRecords", result);
              this.pagination = response?.paginationData;
            } else if (code == 400 || code == 205) {
              this.$emit("hideLoader", false);
            }
          }
        });
      }
      else {
        var response = this.$store.getters.getByKey(this.storageKey);
        var result = {
          data: response?.firstPageData.data,
          noRecordFound: false,
          pagination: response?.firstPageData.pagination,
          fullResponse: response
        };
        this.setDataInStore(result);
        this.currentPage = response?.firstPageData.pagination.currentPage;
        this.$emit("getRecords", result);
        this.pagination = response?.firstPageData.pagination;
      }
    }
  },
  watch: {
    forceRerenderPagination() {
      this.getList()
    },
    url(val) {
      this.dataUrl = val;
      this.getList();
    },
    externalTotalRecord(val) {
      this.totalRecords = val;
    },
    force(value) {
      if (value) {
        this.getList();
      }
    },
    multipleTimeForceApi(val){
      console.log(val)
      this.getList()
    },
    defaultLimit(val) {
      this.currentPage = 1
      this.limit = val;
      this.getList();
    },
    currentPage(page) {
      if(typeof this.loadMore != 'undefined'){
        this.getList(page);
      }
      //  this.storageKey = "";
    },
    bodyData() {
      this.getList();
    }
  },
  computed: {
    ...mapState(['forceRerenderPagination']),
    // totalRecords() {
    //   return this.pagination ? this.pagination.total : 0;
    // },
    totalRecords: {
      // getter
      get: function() {
        return this.pagination ? this.pagination.total : 0;
      },
      // setter
      set: function(newValue) {
        this.pagination.total = newValue;
      }
    }
  }
};
</script>
<style>
p.VuePagination__count.VuePagination__count {
  display: none !important;
}
</style>
